import { useEffect, useContext } from "react";

// Dependencies
// Components
import ContentTemplate from "../../ContentTemplate";
// Context
import { StageContext } from "../../../Module/Stage/ModuleStage";
// Styles
import { TextMark } from "../../../Styles/index";

export default function AtrialAutomaticityFoci(props) {
  const contextValue = useContext(StageContext);
  const {
    setActiveMark,
    setActiveMarkData,
    activeMark,
    clickTextMark,
  } = contextValue;

  const loadMarkData = [
    {
      id: 0,
      img:
        "https://medzcool-images.s3.amazonaws.com/overdrive-suppression-atrial.png",
    },
  ];
  useEffect(() => {
    setActiveMark(0);
    setActiveMarkData(loadMarkData);
  }, []);

  return (
    <ContentTemplate>
      <p>
        The atria have potential automaticity foci if normal pacemaking fails.
        These automaticity foci can assume active pacemaking responsibility in
        its inherent rate range of about 60 to 80 per minute.
      </p>
      <p>
        For example, if the SA Node fails to depolarize and pace the heart, an
        atrial automaticity focus can assume the active pacemaking
        responsibility while also overdrive-suppressing all lower levels of
        potential automaticity foci with slower inherent rates.
      </p>
    </ContentTemplate>
  );
}
